import { React, useEffect, useState } from 'react'
import { MapContainer, TileLayer, Marker, Popup, Circle, useMap } from 'react-leaflet'
import L from 'leaflet'
import axios from 'axios'
import io from "socket.io-client";
import MARK from '../rsc/marker/male_marker_blue.png'
import { makeStyles, Fab } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import moment from 'moment'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const { REACT_APP_API_PATH } = process.env;
const MySwal = withReactContent(Swal)

const useStyles = makeStyles((themes) => ({
  fab: {
    margin: 0,
    top: 'auto',
    right: 15,
    bottom: 80,
    left: 'auto',
    position: 'absolute',
    zIndex: 999
  },
  mainContainer: {
    height: "100vh",
    zIndex: 0
  },
}))



const SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH;
export default function Positioning() {
  const classes = useStyles();
  const [state, setState] = useState({
    myPosition: {
      latitude: -6.200000,
      longitude: 106.816666
    },
    mobileView: false
  })
  const [userPosition, setUserPosition] = useState([])
  const { mobileView } = state;
  const redOptions = { color: 'red' }
  const [map, setMap] = useState(null)
  const [zoomLevel,setZoomLevel] = useState(0);

  const Toast = MySwal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    // timer: 3000,
    timerProgressBar: false,
  })

  useEffect(() => {

    const setResponsiveness = () => {
      return window.innerWidth < 900
      ? setState((prevState) => ({ ...prevState, mobileView: true }))
      : setState((prevState) => ({ ...prevState, mobileView: false }));
    };
    
    const socket = io(SOCKET_PATH,{
      path:'/ws'
    });
    console.log(SOCKET_PATH)
    socket.on("connect", (payload) => {
      console.log("socket connected :", socket.id);

        socket.emit('getPosition',{fullname:"padlan alqinsi"})
      });
      
    socket.on('returnPosition', (payload) => {
      let data = payload;
      data.map(person => {
        handleSocket(person);
      })
    });

    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(function (position) {
        // console.log("Latitude is :", position.coords.latitude);
        // console.log("Longitude is :", position.coords.longitude);
        let myPosition = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          heading: position.coords.heading,
        }
        setState({ ...state, myPosition: myPosition })
      });
    }

    const updateLocation = setInterval(() => {
      socket.emit('getPosition', { fullname: "padlan alqinsi" })
    }, 10000);

    const afkChecker = setInterval(()=> {
      let data = userPosition;
      let afkArr = [];
      data.map((a,b)=>{
        let afk = moment.duration(moment().diff(a.timestamp)).minutes();
        if(afk>1)
        {
          data.splice(b,1)
          console.log(a.fullname,"AFK");
          
        }
      })
      setUserPosition(data)
    },30000);

    const geofencing = setInterval(()=>{
      let myPos = state.myPosition;
      let otherPos = userPosition;
      if(otherPos.length>0)
      {
        otherPos.map((person)=>{
          let distanceBetween = calculateDistance(myPos.latitude,myPos.longitude,person.lat,person.lon,"m");
          let roundedDistance = Math.round(distanceBetween);
          console.log("Warning " ,person.fullname," aproximately ",roundedDistance,"m apart!");
          Toast.fire({
            icon: 'warning',
            title: `${person.fullname} is too far away`
          })
          // MySwal.fire({
          //   title: <p>Hello World</p>,
          //   footer: 'Copyright 2018',
          // })
        })
      }
    },10000)
    
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
    return ()=> {
      clearInterval(afkChecker)
      clearInterval(updateLocation)
      clearInterval(geofencing)
      socket.emit('closeConnection',socket.id)
      socket.disconnect()
    }
  }, [userPosition]);


  function DrawMarker(props) {
    
    const GreyMarker = new L.icon({
      popupAnchor: [0, -70],
      iconSize: [40, 70],
      iconAnchor: [20, 70],
      iconUrl: MARK
    })
    return (
      <Marker key={props.ids} position={[props.lat, props.lon]}>
        <Popup>
          <table>
            <tbody>
            <tr><th>Nama</th><td>{props.fullname}</td></tr>
            <tr><th>Umur</th><td>{props.age}</td></tr>
            <tr><th>Last Seen</th><td>{moment(props.timestamp).format('hh:mm')}</td></tr>
            </tbody>
          </table>
        </Popup>
      </Marker>
    )
  }

  const CustomButton = () => {
    return (
      <div className={classes.fab}>
        <Fab size="medium" color="primary" aria-label="add" onClick={toMyPos}>
          <AddIcon />
        </Fab>
      </div>
    )
  }

  const toMyPos = () => {
    map.setView([state.myPosition.latitude, state.myPosition.longitude], map.getZoom(), {
      "animate": true,
      "pan": {
        "duration": .5
      }
    })
  }

  const MainMap = () => {
    const map = useMap();
    return null
  }

  const setContainerClass = (x) => {
    return x
      ? () => classes.mobileContainer
      : () => classes.desktopContainer
  }

  const handleSocket = (payload) => {
    let raw = payload;
    let onlineArr = userPosition;
    let indexFound = 0;
    let founded = false;
    onlineArr.map((person, i) => {
      if (person.chip_id === raw.chip_id) {
        indexFound = i;
        founded = true
      }
    })
    if (founded) {
      onlineArr[indexFound] = raw;
      console.log("updated ", raw.fullname);
    }
    else {
      onlineArr.push(raw)
      console.log("new entry ", raw.fullname);
    }
    setUserPosition(onlineArr)
    // console.log(onlineArr);
  }

  const calculateDistance = (lat1, lon1, lat2, lon2, unit)=> {
    if ((lat1 === lat2) && (lon1 === lon2)) {
      return 0;
    }
    else {
      let radlat1 = Math.PI * lat1 / 180;
      let radlat2 = Math.PI * lat2 / 180;
      let theta = lon1 - lon2;
      let radtheta = Math.PI * theta / 180;
      let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit === "K") { dist = dist * 1.609344 }
      if (unit === "N") { dist = dist * 0.8684 }
      if (unit === "m") { dist = dist * 1.609344 * 1000}
      return dist;
    }
  }

  return (
    <div>
      <MapContainer whenCreated={setMap} zoomControl={false} center={[state.myPosition.latitude, state.myPosition.longitude]} zoom={8} scrollWheelZoom={true} className={classes.mainContainer}>
        {/* <MainMap/> */}
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {userPosition.map((a) => <DrawMarker ids={Math.random().toString(36).substr(2, 9)} lat={a.lat} lon={a.lon} chip_id={a.chip_id} fullname={a.fullname} gender={a.gender} age={a.age} timestamp={a.timestamp} />)}
        <Circle center={[state.myPosition.latitude, state.myPosition.longitude]} pathOptions={redOptions} radius={100}>
        </Circle>
      </MapContainer>
      <CustomButton />
      {/* {!(mobileView) ? <CustomButton /> : null} */}
    </div>
  )
}
